import axios from "@/utils/request.js";
import qs from "qs"
var baseUrl = process.env.NODE_ENV === 'production' ? '' : process.env.VUE_APP_BASE_API
// 获取活动征集内容
const getColDetail = (params) => axios({
    url: "/api/web-operate/collect/manager/col/detail",
    method: 'get',
    params
})
//提交活动征集内容
const getColRec = (data) => axios({
    url: "/api/web-operate/collect/manager/rec/addNoToken",
    method: 'post',
    data
})
//提交活动征集内容有token
const getColRecAdd = (data) => axios({
    url: "/api/web-operate/collect/manager/rec/add",
    method: 'post',
    data
})
//获取用户提交提交次数
const subBalance = (params) => axios({
    url: "/api/web-operate/collect/manager/col/subBalance",
    method: 'get',
    params
})
//文件上传到隐藏库
const uploadFile = (data) => axios({
    url: "/api/web-manager/file/manager/upload/hide",
    method: 'post',
    data
})
//  获取文件预览路径
const filePerviewPath = (data) => {
    let url = baseUrl + `/api/web-manager/file/manager/redirect/${data.id}/${data.type}`
    return url
};

//检查活动参与人数是否达到上限
const getSubmitMax = (params) => axios({
    url: "/api/web-operate/collect/manager/col/participateCount",
    method: 'get',
    params
})
export {
    getColDetail,
    getColRec,
    getColRecAdd,
    subBalance,
    uploadFile,
    filePerviewPath,
    getSubmitMax
}